import "./BambooHall.module.css";
import Header from "@/reusable_sections/Header";
import RiverfrontEscapeHero from "./sections/RiverfrontEscapeHero";
import AudioAndVisualTechnology from "./sections/AudioAndVisualTechnology";
import InquiryForEvents from "./sections/InquiryForEvents";
import Footer from "@/reusable_sections/Footer";
export default function BambooHallPage() {
  return <div>
      <Header />
      <RiverfrontEscapeHero />
      <AudioAndVisualTechnology />
      <InquiryForEvents />
      <Footer />
    </div>;
}